module.exports = __webpack_public_path__ + "static/26-dd134320b1fda0515376189637f4c910.jpg";